<h2 mat-dialog-title>Confirmação</h2>
<mat-dialog-content>
  <p>Você tem certeza que deseja remover a restrição?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Não</button>
  <button mat-button color="warn" (click)="onConfirm()">Sim</button>
</mat-dialog-actions> 